import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Award({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg width={'16px'} height={'24px'} viewBox={'0 0 16 24'}>
        <g
          stroke={'none'}
          strokeWidth={'1'}
          className={'icon__fill'}
          fillRule={'evenodd'}
        >
          <g transform={'translate(-4.000000, 0.000000)'} fillRule={'nonzero'}>
            <path
              d={
                'M12,16 C7.581722,16 4,12.418278 4,8 C4,3.581722 7.581722,0 12,0 C16.418278,0 20,3.581722 20,8 C20,12.418278 16.418278,16 12,16 Z M12,14 C15.3137085,14 18,11.3137085 18,8 C18,4.6862915 15.3137085,2 12,2 C8.6862915,2 6,4.6862915 6,8 C6,11.3137085 8.6862915,14 12,14 Z M7.51449576,23.8574929 C6.79638903,24.288357 5.89844315,23.6984938 6.0087057,22.8683352 L7.2187057,13.7583352 C7.29142215,13.2108585 7.79418805,12.8259893 8.34166478,12.8987057 C8.8891415,12.9714221 9.27401075,13.4741881 9.2012943,14.0216648 L8.26444368,21.0751434 L11.4855042,19.1425071 C11.8021866,18.9524976 12.1978134,18.9524976 12.5144958,19.1425071 L15.7358817,21.0753387 L14.7986869,14.0115229 C14.7260488,13.4640358 15.11099,12.961325 15.6584771,12.8886869 C16.2059642,12.8160488 16.708675,13.20099 16.7813131,13.7484771 L17.9913131,22.8684771 C18.1014481,23.6985855 17.2035539,24.2883227 16.4855042,23.8574929 L12,21.1661904 L7.51449576,23.8574929 Z'
              }
            ></path>
          </g>
        </g>
      </svg>
    </div>
  )
}

Award.propTypes = {
  className: PropTypes.string,
}
